var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.6,12.25l-2.15-2.15c-.183-.183-.417-.275-.7-.275s-.517.092-.7.275c-.183.183-.275.417-.275.7s.092.517.275.7l2.85,2.85c.2.2.433.3.7.3s.5-.1.7-.3l5.65-5.65c.183-.183.275-.417.275-.7s-.092-.517-.275-.7c-.183-.183-.417-.275-.7-.275s-.517.092-.7.275l-4.95,4.95Zm-5.6,5.75h14V4H2v14Zm0,2c-.55,0-1.021-.196-1.413-.587-.391-.392-.587-.863-.587-1.413V4c0-.55.196-1.021.587-1.413.392-.391.863-.587,1.413-.587h4.2c.217-.6.579-1.083,1.088-1.45.508-.367,1.079-.55,1.712-.55s1.204.183,1.713.55c.508.367.87.85,1.087,1.45h4.2c.55,0,1.021.196,1.413.587.391.392.587.863.587,1.413v14c0,.55-.196,1.021-.587,1.413-.392.391-.863.587-1.413.587H2ZM9,3.25c.217,0,.396-.071.538-.213.141-.141.212-.32.212-.537s-.071-.396-.212-.538c-.142-.141-.321-.212-.538-.212s-.396.071-.537.212c-.142.142-.213.321-.213.538s.071.396.213.537c.141.142.32.213.537.213Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkClipboard);
export default __webpack_public_path__ + "static/media/Checkmark-Clipboard.5980ad9817ad0f06648d2daa31199c0d.svg";
export { ForwardRef as ReactComponent };